import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  datasetDetails: {
    marginBottom: '1rem',
  },

  datasetHead: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1.3rem',
  },

  datasetName: {
    flex: 1,
  },

  buttons: {
    '& button[class^="btn-"]:first-child': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },

    '& button[class^="btn-"]:last-child': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      marginLeft: 0,
      borderLeft: 0,
    },
  },
})

export default useStyles
